// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"176ad1bc","453":"cc4aeffa","732":"89c4443f"}[chunkId] + ".chunk.js";
};